document.addEventListener('change',function(e){if(e.target.matches('[data-sort-by]')){const u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);location.href=u.toString()}});document.addEventListener('click',function(e){const reveal=e.target.closest('[data-reveal]');if(reveal){const target=document.querySelector(reveal.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth'})}}});
/* CARALM / producto: disponibilidad y cantidad sincronizadas con la variante elegida. */
(function(){
  const sync=function(select){
    const option=select?.selectedOptions?.[0];
    const form=select?.closest('form.product-form');
    if(!option||!form)return;
    const info=form.closest('.product-info');
    const available=option.dataset.available==='true';
    const price=info?.querySelector('[data-product-price]');
    const status=form.querySelector('[data-variant-status]');
    const quantity=form.querySelector('[data-product-quantity]');
    const add=form.querySelector('[data-add-to-cart]');
    const buy=form.querySelector('[data-buy-now]');
    const addLabel=form.querySelector('[data-button-label]');
    const buyLabel=form.querySelector('[data-buy-now-label]');
    const rawLimit=option.dataset.inventoryLimit;
    const limit=(rawLimit!==undefined&&rawLimit!=='')?Number(rawLimit):null;
    if(price)price.textContent=option.dataset.price||price.textContent;
    if(add)add.disabled=!available;
    if(buy)buy.disabled=!available;
    if(addLabel)addLabel.textContent=available?'Añadir a la bolsa':'Agotado';
    if(buyLabel)buyLabel.textContent=available?'Comprar ahora':'Agotado';
    if(status)status.textContent=available?'Talla disponible':'Talla agotada';
    if(quantity){
      if(available&&Number.isInteger(limit)&&limit>0){
        quantity.max=String(limit);
        if(Number(quantity.value)>limit)quantity.value=String(limit);
      }else{
        quantity.removeAttribute('max');
      }
    }
  };
  const init=function(){
    document.querySelectorAll('[data-variant-select]').forEach(sync);
  };
  document.addEventListener('change',function(event){
    if(event.target.matches('[data-variant-select]'))sync(event.target);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

document.addEventListener('click',async function(e){const button=e.target.closest('[data-buy-now]');if(!button)return;const form=button.closest('form.product-form');if(!form?.reportValidity())return;const variantId=form.querySelector('[name="id"]')?.value;const quantity=Math.max(1,Number.parseInt(form?.querySelector('[name="quantity"]')?.value||'1',10)||1);const message=form?.querySelector('[data-product-form-message]');if(!variantId)return;const original=button.innerHTML;button.disabled=true;button.textContent='Preparando compra…';if(message)message.textContent='';try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:quantity}]})});if(!response.ok)throw new Error('Cart add failed');await response.json();window.location.assign(root+'checkout')}catch(error){if(message)message.textContent='No se ha podido iniciar la compra. Inténtalo de nuevo.';button.disabled=false;button.innerHTML=original}});
/* CARALM / bienvenida v4: una sola vez, confirmada al cerrar o entrar. */
(function(){
  const init=function(){
    const dialog=document.querySelector('[data-announcement-popup]');
    if(!dialog)return;
    const key='caralm-welcome-seen-v4';
    const testMode=new URLSearchParams(window.location.search).get('caralm_popup_test')==='1';
    if(window.Shopify?.designMode&&!testMode)return;
    const alreadySeen=function(){
      try{return window.localStorage.getItem(key)==='1'}catch(error){return false}
    };
    const remember=function(){
      if(testMode)return;
      try{window.localStorage.setItem(key,'1')}catch(error){}
    };
    if(!testMode&&alreadySeen())return;
    let shown=false;
    let dismissed=false;
    let timer=null;
    const close=function(event){
      if(event)event.preventDefault();
      dismissed=true;
      if(dialog.open){
        if(typeof dialog.close==='function')dialog.close();
        else dialog.removeAttribute('open');
      }
      remember();
    };
    dialog.querySelector('[data-announcement-close]')?.addEventListener('click',close);
    dialog.querySelector('[data-announcement-link]')?.addEventListener('click',function(){
      dismissed=true;
      remember();
    });
    dialog.addEventListener('close',function(){
      dismissed=true;
      remember();
    });
    dialog.addEventListener('click',function(event){
      if(event.target===dialog)close(event);
    });
    const open=function(){
      timer=null;
      if(shown||dismissed||dialog.open||document.visibilityState==='hidden'||!document.body.contains(dialog))return;
      try{
        if(typeof dialog.showModal==='function')dialog.showModal();
        else dialog.setAttribute('open','');
      }catch(error){
        if(!dialog.open)dialog.setAttribute('open','');
      }
      if(dialog.open)shown=true;
    };
    const delay=Math.max(0,Math.min(5,Number(dialog.dataset.delay)||0))*1000;
    const schedule=function(){
      if(shown||dismissed||dialog.open||document.visibilityState==='hidden')return;
      if(timer!==null)window.clearTimeout(timer);
      timer=window.setTimeout(open,delay);
    };
    document.addEventListener('visibilitychange',function(){
      if(document.visibilityState==='visible')schedule();
    });
    window.addEventListener('pageshow',schedule);
    schedule();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* CARALM: responsive size table wrapper, preserving the native table structure. */
(function(){
  const init=function(){
    document.querySelectorAll('.product-description table').forEach(function(table){
      if(table.parentElement?.classList.contains('caralm-table-scroll'))return;
      const wrap=document.createElement('div');
      wrap.className='caralm-table-scroll';
      wrap.tabIndex=0;
      wrap.setAttribute('role','region');
      wrap.setAttribute('aria-label','Tabla de medidas de la prenda');
      table.parentNode.insertBefore(wrap,table);
      wrap.appendChild(table);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* CARALM: keep the selected variant and purchase action accessible after scrolling. */
(function(){
  const init=function(){
    const sticky=document.querySelector('[data-caralm-sticky-purchase]');
    if(!sticky)return;
    const form=document.getElementById(sticky.dataset.formId);
    const primary=form?.querySelector('[data-add-to-cart]');
    const select=form?.querySelector('[data-variant-select]');
    const stickyAdd=sticky.querySelector('[data-sticky-add]');
    const stickyLabel=sticky.querySelector('[data-sticky-label]');
    const stickyPrice=sticky.querySelector('[data-sticky-price]');
    if(!form||!primary||!stickyAdd)return;
    let originalVisible=true;
    const updateVisibility=function(){
      const show=window.matchMedia('(max-width: 749px)').matches&&window.scrollY>120&&!originalVisible;
      sticky.classList.toggle('is-visible',show);
      sticky.setAttribute('aria-hidden',String(!show));
      document.body.classList.toggle('has-caralm-sticky-purchase',show);
    };
    const updateVariant=function(){
      const option=select?.selectedOptions?.[0];
      const available=option?option.dataset.available==='true':!primary.disabled;
      stickyAdd.disabled=!available;
      stickyLabel.textContent=available?'Añadir a la bolsa':'Agotado';
      if(option?.dataset.price)stickyPrice.textContent=option.dataset.price;
    };
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        originalVisible=entries[0].isIntersecting;
        updateVisibility();
      },{threshold:0}).observe(primary);
    } else {
      const compute=function(){const rect=primary.getBoundingClientRect();originalVisible=rect.bottom>0&&rect.top<window.innerHeight;updateVisibility()};
      window.addEventListener('scroll',compute,{passive:true});
      window.addEventListener('resize',compute);
      compute();
    }
    window.addEventListener('scroll',updateVisibility,{passive:true});
    window.addEventListener('resize',updateVisibility);
    select?.addEventListener('change',updateVariant);
    updateVariant();
    updateVisibility();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


/* CARALM / PDP: navegación completa de fotografías, sin limitar la galería a cinco. */
(function(){
  function init(){
    const gallery=document.querySelector('[data-product-gallery]');
    const controls=document.querySelector('[data-gallery-controls]');
    if(!gallery||!controls)return;
    const images=Array.from(gallery.querySelectorAll('img'));
    const prev=controls.querySelector('[data-gallery-prev]');
    const next=controls.querySelector('[data-gallery-next]');
    const counter=controls.querySelector('[data-gallery-count]');
    if(!prev||!next||!counter)return;
    if(images.length<2){controls.hidden=true;return}
    let current=0;
    const update=function(){
      const box=gallery.getBoundingClientRect();
      const midpoint=box.left+box.width/2;
      let distance=Infinity;
      images.forEach(function(img,i){
        const rect=img.getBoundingClientRect();
        const delta=Math.abs(rect.left+rect.width/2-midpoint);
        if(delta<distance){distance=delta;current=i}
      });
      counter.textContent=(current+1)+' / '+images.length;
      prev.disabled=current===0;
      next.disabled=current===images.length-1;
    };
    const go=function(index){
      const i=Math.min(images.length-1,Math.max(0,index));
      const rect=images[i].getBoundingClientRect();
      const root=gallery.getBoundingClientRect();
      const left=gallery.scrollLeft+rect.left-root.left-(gallery.clientWidth-rect.width)/2;
      gallery.scrollTo({left:left,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      current=i;
      counter.textContent=(i+1)+' / '+images.length;
      prev.disabled=i===0;
      next.disabled=i===images.length-1;
    };
    prev.addEventListener('click',function(){go(current-1)});
    next.addEventListener('click',function(){go(current+1)});
    gallery.addEventListener('scroll',update,{passive:true});
    gallery.addEventListener('keydown',function(e){
      if(e.target!==gallery)return;
      if(e.key==='ArrowRight'){e.preventDefault();go(current+1)}
      if(e.key==='ArrowLeft'){e.preventDefault();go(current-1)}
    });
    window.addEventListener('resize',update);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* CARALM / PDP: muestra la tabla específica dentro de «Guía de tallas».
   Con JavaScript desactivado, el enlace original sigue llevando a la descripción. */
(function(){
  function init(){
    const slot=document.querySelector('[data-caralm-size-guide-inline]');
    const description=document.querySelector('.product-description');
    if(!slot||!description)return;
    let guide=description.querySelector('.caralm-size-guide');
    if(guide){
      if(!guide.querySelector('table'))return;
    }else{
      const heading=Array.from(description.children).find(function(node){
        return /^H[2-4]$/.test(node.tagName)&&/guía de tallas/i.test(node.textContent||'');
      });
      if(!heading)return;
      guide=document.createElement('div');
      guide.className='caralm-size-guide';
      guide.setAttribute('data-caralm-size-guide','true');
      let node=heading;
      while(node){
        const next=node.nextElementSibling;
        guide.appendChild(node);
        node=next;
      }
      if(!guide.querySelector('table')){description.appendChild(guide);return}
    }
    slot.replaceChildren(guide);
    slot.closest('details')?.classList.add('has-inline-size-guide');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
